import { render, staticRenderFns } from "./createWarehouse.vue?vue&type=template&id=2b107866&scoped=true"
import script from "./createWarehouse.vue?vue&type=script&lang=js"
export * from "./createWarehouse.vue?vue&type=script&lang=js"
import style0 from "./createWarehouse.vue?vue&type=style&index=0&id=2b107866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b107866",
  null
  
)

export default component.exports